import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SessionDetailsCardComponent } from './session-details-card.component';
import { SessionDetailsCardPipeModule } from './pipe/session-details-card-pipe.module';
import { LuIconModule } from 'lu-icon';

const declarations = [SessionDetailsCardComponent];

const imports = [CommonModule, SessionDetailsCardPipeModule, LuIconModule, TranslateModule];

@NgModule({
	declarations,
	imports,
	exports: [...declarations]
})
export class SessionDetailsCardModule {}
